import MyProps, { EDIT_TYPE } from './MyProps';
import { useUserContext } from '../contexts/UserContext';
import { MODEL_TYPES } from '../constants/constants';
import { MY_PRODUCTS_ROUTE } from '../constants/routePathConstants';
import { MxEvent } from '../common/Mixpanel';

export default function MyProducts3dModel({
  cardType = 'products',
  useGlobalSearch,
  noDataText = `You don't have any Models.`,
  apiConfig,
  cardProps,
  hideBreadcrumbs = false,
  designV2,
  hideStickyHeader = null,
}) {
  const { currentUser } = useUserContext();
  const userCurrentOrg = currentUser?.organization;

  const breadcrumbs = [
    {
      link: MY_PRODUCTS_ROUTE,
      label: 'My products',
      mx_event: MxEvent.VISITED_MY_PRODUCTS,
    },
    {
      label: 'My Models',
    },
  ];

  return (
    <MyProps
      hideStickyHeader={hideStickyHeader}
      designV2={designV2}
      title="My Models"
      pageTitle="My Models - My Products"
      cardType={cardType}
      breadcrumbs={hideBreadcrumbs ? [] : breadcrumbs}
      editType={EDIT_TYPE.MODEL_3D}
      modelType={MODEL_TYPES.THREEDMODELS}
      noDataText={noDataText}
      useGlobalSearch={useGlobalSearch}
      cardProps={cardProps}
      apiConfig={{
        defaultBrands: userCurrentOrg,
        ...apiConfig,
      }}
    />
  );
}
